export const HEADING_AND_MESSAGES_STYLE = (base) => ({
  ...base,
  color: 'var(--ds-text-subtlest, var(--ds-fb-text-subtlest))',
});
